type actionNameCreator = (actionName: string) => string;

// 创建预订
const reserveCreateAction: actionNameCreator = (actionName) => `RESERVE_CREATE@${actionName}`;
export const ReserveCreateAction = {
  initDefaultState: reserveCreateAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: reserveCreateAction('SET_LOADING_STATUS'),
  setInitStatus: reserveCreateAction('SET_INIT_STATUS'),
  setModifyStatus: reserveCreateAction('SET_MODIFY_STATUS'),
  setCommonData: reserveCreateAction('SET_COMMON_DATA'),
  setCustomerData: reserveCreateAction('SET_CUSTOMER_DATA'),
  setDayTimeData: reserveCreateAction('SET_DAY_TIME'),
  setHourTimeData: reserveCreateAction('SET_HOUR_TIME'),
  setChannelData: reserveCreateAction('SET_CHANNEL_CONFIG'),
  setChannelList: reserveCreateAction('SET_CHANNEL_LIST'),
  setStrategyList: reserveCreateAction('SET_STRATEGY_LIST'),
  setAllRoomList: reserveCreateAction('SET_ROOM_ALL_LIST'),
  setRoomNotice: reserveCreateAction('SET_ROOM_NOTICE_DATA'),
  setCheckedList: reserveCreateAction('SET_ROOM_CHECKED_LIST'),
  setRentRoomList: reserveCreateAction('SET_ROOM_RENT_LIST'),
  setRoomPriceList: reserveCreateAction('SET_ROOM_PRICE_LIST'),
  setRemarkInfo: reserveCreateAction('SET_REMARK_INFO'),
};

// 取消预订
const reserveCancelAction: actionNameCreator = (actionName) => `RESERVE_CANCEL@${actionName}`;
export const ReserveCancelAction = {
  initDefaultState: reserveCancelAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: reserveCancelAction('SET_LOADING_STATUS'),
  setInitStatus: reserveCancelAction('SET_INIT_STATUS'),
  setRentRecordList: reserveCancelAction('SET_RECORD_LIST'),
  setChannelList: reserveCancelAction('SET_ALL_CHANNEL_LIST'),
};

// 创建入住
const checkInCreateAction: actionNameCreator = (actionName) => `CHECK_IN_CREATE@${actionName}`;
export const CheckInCreateAction = {
  initDefaultState: checkInCreateAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: checkInCreateAction('SET_LOADING_STATUS'),
  setInitStatus: checkInCreateAction('SET_INIT_STATUS'),
  setModifyStatus: checkInCreateAction('SET_MODIFY_STATUS'),
  setCommonData: checkInCreateAction('SET_COMMON_DATA'),
  setGuestData: checkInCreateAction('SET_CUSTOMER_DATA'),
  setDayTimeData: checkInCreateAction('SET_DAY_TIME'),
  setHourTimeData: checkInCreateAction('SET_HOUR_TIME'),
  setChannelData: checkInCreateAction('SET_CHANNEL_CONFIG'),
  setChannelList: checkInCreateAction('SET_CHANNEL_LIST'),
  setStrategyList: checkInCreateAction('SET_STRATEGY_LIST'),
  setAllRoomList: checkInCreateAction('SET_ROOM_ALL_LIST'),
  setRoomNotice: checkInCreateAction('SET_ROOM_NOTICE_DATA'),
  setCheckedList: checkInCreateAction('SET_ROOM_CHECKED_LIST'),
  setRentRoomList: checkInCreateAction('SET_ROOM_RENT_LIST'),
  setRoomPriceList: checkInCreateAction('SET_ROOM_PRICE_LIST'),
  setRemarkInfo: checkInCreateAction('SET_REMARK_INFO'),
  setCardNotice: checkInCreateAction('SET_CARD_NOTICE_DATA'),
};

// 预订转入住
const checkInByReserveAction: actionNameCreator = (actionName) =>
  `CHECK_IN_BY_RESERVE@${actionName}`;
export const CheckInByReserveAction = {
  initDefaultState: checkInByReserveAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: checkInByReserveAction('SET_LOADING_STATUS'),
  setChannelList: checkInByReserveAction('SET_CHANNEL_LIST'),
  setInitStatus: checkInByReserveAction('SET_INIT_STATUS'),
  setModifyStatus: checkInByReserveAction('SET_MODIFY_STATUS'),
  setRentTimeInfo: checkInByReserveAction('SET_RENT_TIME'),
  setGuestData: checkInByReserveAction('SET_CUSTOMER_DATA'),
  setAllRoomList: checkInCreateAction('SET_ROOM_ALL_LIST'),
  setRentRoomList: checkInCreateAction('SET_ROOM_RENT_LIST'),
  setRoomPriceList: checkInCreateAction('SET_ROOM_PRICE_LIST'),
  setRemarkInfo: checkInCreateAction('SET_REMARK_INFO'),
  setCardNotice: checkInCreateAction('SET_CARD_NOTICE_DATA'),
  setOriginCouponList: checkInCreateAction('SET_ORIGIN_COUPON_LIST'),
};

// 续住
const renewalCreateAction: actionNameCreator = (actionName) =>
  `NORMAL_RENEWAL_CREATE@${actionName}`;
export const RenewalCreateAction = {
  initDefaultState: renewalCreateAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: renewalCreateAction('SET_LOADING_STATUS'),
  setInitStatus: renewalCreateAction('SET_INIT_STATUS'),
  setModifyStatus: renewalCreateAction('SET_MODIFY_STATUS'),
  setCommonData: renewalCreateAction('SET_COMMON_DATA'),
  setDayTimeData: renewalCreateAction('SET_DAY_TIME'),
  setHourTimeData: renewalCreateAction('SET_HOUR_TIME'),
  setChannelData: renewalCreateAction('SET_CHANNEL_CONFIG'),
  setAllChannelList: renewalCreateAction('SET_ALL_CHANNEL_LIST'),
  setStrategyList: renewalCreateAction('SET_STRATEGY_LIST'),
  setRentRoomList: renewalCreateAction('SET_ROOM_RENT_LIST'),
  setRoomPriceList: renewalCreateAction('SET_ROOM_PRICE_LIST'),
};

// 直连预订续住
const directRenewalAction: actionNameCreator = (actionName) =>
  `DIRECT_RENEWAL_CREATE@${actionName}`;
export const DirectRenewalCreateAction = {
  initDefaultState: directRenewalAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: directRenewalAction('SET_LOADING_STATUS'),
  setInitStatus: directRenewalAction('SET_INIT_STATUS'),
  setModifyStatus: renewalCreateAction('SET_MODIFY_STATUS'),
  setRentRoomList: renewalCreateAction('SET_RENT_ROOM_LIST'),
};

// 预订换房
const reserveExchangeAction: actionNameCreator = (actionName) => `RESERVE_EXCHANGE@${actionName}`;
export const ReserveExchangeAction = {
  initDefaultState: reserveExchangeAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: reserveExchangeAction('SET_LOADING_STATUS'),
  setInitStatus: reserveExchangeAction('SET_INIT_STATUS'),
  setModifyStatus: reserveExchangeAction('SET_MODIFY_STATUS'),
  setCommonData: reserveExchangeAction('SET_COMMON_DATA'),
  setRentTimeInfo: reserveExchangeAction('SET_RENT_TIME'),
  setAllRoomList: reserveExchangeAction('SET_ROOM_ALL_LIST'),
  setRentRoomList: reserveExchangeAction('SET_ROOM_RENT_LIST'),
  setRoomPriceList: reserveExchangeAction('SET_ROOM_PRICE_LIST'),
  setMarketPriceList: reserveExchangeAction('SET_MARKET_PRICE_LIST'),
};

// 入住换房
const checkInExchangeAction: actionNameCreator = (actionName) => `CHECK_IN_EXCHANGE@${actionName}`;
export const CheckInExchangeAction = {
  initDefaultState: checkInExchangeAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: checkInExchangeAction('SET_LOADING_STATUS'),
  setInitStatus: checkInExchangeAction('SET_INIT_STATUS'),
  setModifyStatus: checkInExchangeAction('SET_MODIFY_STATUS'),
  setCardStatus: checkInExchangeAction('SET_CARD_MANAGE_STATUS'),
  setCommonData: checkInExchangeAction('SET_COMMON_DATA'),
  setRentTimeInfo: checkInExchangeAction('SET_RENT_TIME'),
  setAllRoomList: checkInExchangeAction('SET_ROOM_ALL_LIST'),
  setRentRoomList: checkInExchangeAction('SET_ROOM_RENT_LIST'),
  setRoomPriceList: checkInExchangeAction('SET_ROOM_PRICE_LIST'),
  setMarketPriceList: checkInExchangeAction('SET_MARKET_PRICE_LIST'),
  setStoreRemark: checkInExchangeAction('SET_STORE_REMARKS'),
};

// 退房
const checkOutAction: actionNameCreator = (actionName) => `CHECK_OUT@${actionName}`;
export const CheckOutAction = {
  initDefaultState: checkOutAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: checkOutAction('SET_LOADING_STATUS'),
  setInitStatus: checkOutAction('SET_INIT_STATUS'),
  setRentRoomList: checkOutAction('SET_RENT_ROOM_LIST'),
  setOvertimePriceAdjustList: checkOutAction('SET_OVERTIME_PRICE_ADJUST_LIST'),
  setCardStatus: checkOutAction('SET_CARD_MANAGE_STATUS'),
  setPeripheralReturnList: checkOutAction('SET_PERIPHERAL_RETURN_LIST'),
};

// CRS 预订详情
const reserveDetailAction4CRS: actionNameCreator = (actionName) =>
  `CRS_RESERVE_DETAIL@${actionName}`;
export const CRSReserveDetailAction = {
  initDefaultState: reserveDetailAction4CRS('INIT_DEFAULT_STATE'),
  setLoadingStatus: reserveDetailAction4CRS('SET_LOADING_STATUS'),
  setInitStatus: reserveDetailAction4CRS('SET_INIT_STATUS'),
};

// CRS 预订创建
const reserveCreateAction4CRS: actionNameCreator = (actionName) =>
  `CRS_RESERVE_DETAIL@${actionName}`;
export const CRSReserveCreateAction = {
  initDefaultState: reserveCreateAction4CRS('INIT_DEFAULT_STATE'),
  setLoadingStatus: reserveCreateAction4CRS('SET_LOADING_STATUS'),
  setInitStatus: reserveCreateAction4CRS('SET_INIT_STATUS'),
  setModifyStatus: reserveCreateAction4CRS('SET_MODIFY_STATUS'),
  setAllRoomList: reserveCreateAction4CRS('SET_ROOM_ALL_LIST'),
  setRentRoomList: reserveCreateAction4CRS('SET_ROOM_RENT_LIST'),
};

// 预订修改
const reserveEditorAction: actionNameCreator = (actionName) => `RESERVE_EDITOR@${actionName}`;
export const ReserveEditorAction = {
  initDefaultState: reserveEditorAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: reserveEditorAction('SET_LOADING_STATUS'),
  setInitStatus: reserveEditorAction('SET_INIT_STATUS'),
  setCommonData: reserveEditorAction('SET_COMMON_DATA'),
  setRentTimeData: reserveEditorAction('SET_RENT_TIME'),
  setChannelData: reserveEditorAction('SET_CHANNEL_CONFIG'),
  setChannelList: reserveEditorAction('SET_CHANNEL_LIST'),
  setStrategyList: reserveEditorAction('SET_STRATEGY_LIST'),
  setRentRoomList: reserveEditorAction('SET_ROOM_RENT_LIST'),
  setRoomPriceList: reserveEditorAction('SET_ROOM_PRICE_LIST'),
  setRemarkInfo: reserveEditorAction('SET_REMARK_INFO'),
};

// 入住修改
const checkInEditorAction: actionNameCreator = (actionName) => `CHECK_IN_EDITOR@${actionName}`;
export const CheckInEditorAction = {
  initDefaultState: checkInEditorAction('INIT_DEFAULT_STATE'),
  setLoadingStatus: checkInEditorAction('SET_LOADING_STATUS'),
  setInitStatus: checkInEditorAction('SET_INIT_STATUS'),
  setCommonData: checkInEditorAction('SET_COMMON_DATA'),
  setRentTimeData: checkInEditorAction('SET_RENT_TIME'),
  setChannelData: checkInEditorAction('SET_CHANNEL_CONFIG'),
  setChannelList: checkInEditorAction('SET_CHANNEL_LIST'),
  setStrategyList: checkInEditorAction('SET_STRATEGY_LIST'),
  setRentRoomList: checkInEditorAction('SET_ROOM_RENT_LIST'),
  setRoomPriceList: checkInEditorAction('SET_ROOM_PRICE_LIST'),
  setRemarkInfo: checkInEditorAction('SET_REMARK_INFO'),
};
